import React from 'react'
import './Dashboard.scss'
import LandingPage from '../../component/Layout/Dashboard/LandingPage'
const Dashboard = () => {
  return (
    <div>

      <LandingPage/>
    </div>
  )
}

export default Dashboard
